import React from 'react';

import { Typography } from '@mui/material';

import { ReactComponent as UnauthorizedIcon } from '../../../../assets/icons/lock.svg';
import { useStyles } from './AccessDenied.styles';
import theme from '../../../../styles/theme';

export default function AccessDenied() {
  const { classes } = useStyles(theme);

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <UnauthorizedIcon style={{ width: '140px', height: '115px' }} />
        <div className={classes.mainContent}>
          <Typography variant="h1">Access denied</Typography>
          <Typography variant="text-lg" className={classes.description}>
            Sorry, you are denied access, please contact administrator for
            permissions
          </Typography>
        </div>
      </div>
    </div>
  );
}
